import React, { useEffect, useMemo, useState, useCallback } from 'react'
import {Dropdown } from 'react-bootstrap'
import { PARTICULAR_REQUEST_PARAMETER_LIST_GET } from '../../api/ApiConst';
import { isActiveRecord, isDeleteRecord, isInActiveRecord } from '../common/utilities/ConfirmationAlert';
import RequestParameterAddEdit from './RequestParameterAddEdit';
import * as NavConst from '../constants/NavigationConstants';
import { useNavigate } from 'react-router-dom';
import TableFilter from '../constants/TableFilter';

const RequestParameters = (props) => {
    const navigate = useNavigate();
    const [url, setUrl] = useState("");
    const [selectedRequestId, setSelectedRequestId] = useState(0)
    const [parameterDrawCount, setParameterDrawCount] = useState(0);
    const [showAddModel, setShowAddModel] = useState(false);
    const [parameterObj, setParameterObj] = useState({
        id: "",
        name: "",
        description: "",
        type: "",
        requestId: "",
        required: false,
    });

    const [requestObjects, setRequestObjects] = useState({
        id: "",
        name: "",
    })

    // Show Parameter Add/Edit Model
    const toggleAddModel = () => {
        setShowAddModel(prev => !prev)
    }


    // Request Parameter Create
    const handleAddRequestParameter = () => {
        let rObj = {
            name: "",
            description: "",
            type: "",
            requestId: selectedRequestId,
            required: false,
        };
        setParameterObj(rObj);
        toggleAddModel();
    }

    // Request Parameter Edit
    const handleEditRequestParameter = (row) => {
        let rObj = {
            id: row.id,
            name: row.name,
            description: row.description,
            type: row.type,
            requestId: selectedRequestId,
            required: row.required,
        };
        setParameterObj(rObj);
        toggleAddModel();
    }

    // Navigate Parameter Validation Page
    const navigateParameterValidationPage = (data) => {

        let fetchDetails = {
            parameterData: data,
            requestObjIs: { id: props.id, name: props.requestName },
            type: "fetch",
        };
        let validationUrl = NavConst.VIEW_SINGLE_PARAMETER_VALIDATION_LIST.replaceAll(":requestName/:parameterName", `${props.requestName}/${data.name}`)
        navigate(validationUrl, { state: fetchDetails });
    }

    useEffect(() => {
        if (props.id !== "" || props.id !== undefined) {
            setSelectedRequestId(props.id);
            setRequestObjects({
                id: props.id,
                name: props.requestName
            })
            setUrl(PARTICULAR_REQUEST_PARAMETER_LIST_GET.replaceAll("{request-id}", props.id));
        }
    }, [props]);

    // Attribute Table Action Buttons
    const getRequestParameterActionButtons = (row) => {
        return (
            <Dropdown className='custom-dropdown'>
                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                    <i className="fa fa-chevron-down"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item
                        href={undefined}
                        onClick={() =>
                            // Navigate Parameter Validation Page
                            navigateParameterValidationPage(row)
                        }
                    >
                        <i className="fa-solid fa-plus"></i> Validations
                    </Dropdown.Item>
                    <Dropdown.Item
                        href={undefined}
                        onClick={() =>
                            handleEditRequestParameter(row)
                        }
                    >
                        <i className="fa fa-edit me-2"></i> Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                        href={undefined}
                        onClick={(row) =>
                            isDeleteRecord(row)
                            // handleTableDataDelete(row)
                        }
                    ><i className="fa fa-trash me-2"></i> Delete</Dropdown.Item>
                    <Dropdown.Item
                        href={undefined}
                        onClick={(row) =>
                            isActiveRecord(row)
                        }
                    ><i className="fa fa-circle-check me-2"></i> Active</Dropdown.Item>
                    <Dropdown.Item
                        href={undefined}
                        onClick={(row) =>
                            isInActiveRecord(row)
                        }
                    ><i className="fa fa-circle-xmark me-2" ></i> InActive</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        )
    }

    const getParametersTableView = useCallback(
        () => {
            return (
                <>
                    <div className='card'>
                        <div className="card-body p-0">
                            <div className="col-12 table-info">
                                <div className="d-flex justify-content-center position-relative">
                                    <h5 className='d-inline-block m-0'>Request {props.requestName} Parameters</h5>
                                    <button
                                        type="button"
                                        className="btn btn-primary border-0 new-attribute-btn"
                                        onClick={handleAddRequestParameter}
                                    >
                                        Add New
                                    </button>
                                </div>
                            </div>
                            <div className='col-12 mt-3'>
                                {url !== "" &&
                                    <TableFilter
                                        tableName="request_parameter"
                                        tableUrl={url}
                                        paginationStatus={false}
                                        drawCount={parameterDrawCount}
                                        showRecordUpdateModel={handleEditRequestParameter}
                                        requestObjects={requestObjects}
                                        expandableRows={true}
                                        refreshTableData = {() => {
                                            setParameterDrawCount((prev) => (prev + 1));
                                        }}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </>
            )
        },
        [url, parameterDrawCount],
    );

    return (
        <>

            {getParametersTableView()}
            {
                <RequestParameterAddEdit
                    show={showAddModel}
                    close={toggleAddModel}
                    successCallBack={() => setParameterDrawCount((pre) => (pre + 1))}
                    object={parameterObj}
                />
            }
        </>
    )
}

export default RequestParameters